import Primarytheme from './theme';
import React, { useState, useRef, useEffect } from 'react';

import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import FileUploadIcon from '@mui/icons-material/FileUpload';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as UploadImagesLogo } from '../../logos/upload-images.svg';

import { getContentType } from '../helpers/assets';
import { validateFilenames, VALIDATION_RULES } from '../helpers/filenameValidation';

import { getSessionIdToken } from '../auth/apiAuth'

import axios from 'axios';

const {
    REACT_APP_USER_ID,
    REACT_APP_S3_BUCKET,
    REACT_APP_REGION,
} = process.env;

export default function GenericUpload({ auth, bucket, project_id, folderObjList, selectedFolder, displayName, refresh, direction = 'row', inLaunch = false, idAsset, handleChangeCover }) {

    const fileInputRef = useRef(null);
    //console.log('uploading component ', folderObj, selectedFolder)
    const [openAsset, setOpenAsset] = useState({ open: false, message: '', duration: 6000 });

    const [selectedAssets, setSelectedAssets] = useState({});
    const [assetProgress, setAssetProgress] = useState(0);

    const [isLoadingAsset, setIsLoadingAsset] = useState({});
    const [isDragOver, setIsDragOver] = useState(false);

    const [validationResults, setValidationResults] = useState({});
    const [warningDialogOpen, setWarningDialogOpen] = useState(false);
    const [errorDialogOpen, setErrorDialogOpen] = useState(false);
    const [pendingUpload, setPendingUpload] = useState(null);

    useEffect(() => {
        const results = {};
        Object.entries(selectedAssets).forEach(([folder, files]) => {
            if (files && files.length > 0) {
                results[folder] = validateFilenames(files);
            }
        });
        setValidationResults(results);
    }, [selectedAssets]);

    const getFilesFromDataTransfer = async (dataTransfer) => {
        const files = [];
        const readEntry = (entry) => {
            return new Promise((resolve) => {
                if (entry.isFile) {
                    entry.file(f => { files.push(f); resolve(); });
                } else if (entry.isDirectory) {
                    const reader = entry.createReader();
                    const readAll = (entries = []) => {
                        reader.readEntries(async (batch) => {
                            if (batch.length === 0) {
                                await Promise.all(entries.map(e => readEntry(e)));
                                resolve();
                            } else {
                                readAll([...entries, ...batch]);
                            }
                        });
                    };
                    readAll();
                } else {
                    resolve();
                }
            });
        };
        const items = dataTransfer.items;
        const entries = [];
        for (let i = 0; i < items.length; i++) {
            const entry = items[i].webkitGetAsEntry && items[i].webkitGetAsEntry();
            if (entry) entries.push(entry);
        }
        await Promise.all(entries.map(e => readEntry(e)));
        return files;
    };

    const updateObjState = (stateObj, setStateObj, value, folder) => {
        //console.log('value ', value)
        setStateObj(stateObj => {
            const updatedStateObj = { ...stateObj };
            updatedStateObj[folder] = value;
            return updatedStateObj;
        })
    }

    const handleCloseAsset = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAsset({ open: false, message: '', duration: 6000 });
    };

    const handleClearAssetsAll = (folder) => {

        updateObjState(selectedAssets, setSelectedAssets, [], folder);
        setAssetProgress(0)
        updateObjState(isLoadingAsset, setIsLoadingAsset, false, folder);
    };
    const handleAssetsInput = async (event, folder, folderPath, inLaunch) => {
        //event.preventDefault();
        setSelectedAssets(prev => {
            const existing = prev[folder] ? [...prev[folder]] : [];
            const newFiles = Array.from(event.target.files);
            const existingNames = new Set(existing.map(f => f.name));
            const merged = [...existing, ...newFiles.filter(f => !existingNames.has(f.name))];
            return { ...prev, [folder]: merged };
        });

        if (inLaunch) {
            await handleUploadAsset([event.target.files[0]], folder, folderPath)
            handleChangeCover({ event, id: idAsset, value: event.target.files[0] })
        }
    }

    const handleRemoveFile = (folder, index) => {
        setSelectedAssets(prev => {
            const updated = { ...prev };
            updated[folder] = [...updated[folder]];
            updated[folder].splice(index, 1);
            return updated;
        });
    };

    const formatFileSize = (bytes) => {
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / 1048576).toFixed(1) + ' MB';
    };




    const handleUploadAsset = async (assets, folderName, folderPath) => {

        //updateObjState(assetProgress, setAssetProgress, 10, folderName);
        updateObjState(isLoadingAsset, setIsLoadingAsset, true, folderName);
        try {

            const dirName = folderPath.replace(`${bucket}/`, '');
            const sizing = { total: 0, uploaded: [] };

            for (const f of assets) {
                sizing.total += f.size;
            }

            sizing.uploaded.push(...Array(assets.length).fill(0))

            if (assets.length > 100 || sizing.total > 30000000) {
                setOpenAsset({ open: true, message: 'There are many images to upload or the images to upload are heavy, please do not close the page until the process is finished', duration: null })
            }

            const promises = [];
            let dynamoArr = [];
            let currentSize = 0;
            const failedFiles = [];
            for (let id = 0; id < assets.length; id++) {
                const f = assets[id];
                currentSize += f.size;
                promises.push(
                    new Promise((resolve, reject) => {
                        auth.s3.upload({
                            Body: f, //files[i],
                            Bucket: bucket,
                            Key: dirName + '/' + f.name,//files[i].name,
                            ContentType: getContentType(f.name.split('.').pop())
                        })
                            .on('httpUploadProgress', evt => {
                                sizing.uploaded[id] = evt.loaded;
                                const loadedPart = sizing.uploaded.reduce((partialSum, a) => partialSum + a, 0)
                                // console.log(id, loadedPart, sizing.total, loadedPart / sizing.total)
                                setAssetProgress(loadedPart / sizing.total * 100);
                            })
                            .send((err, data) => {
                                if (err) {
                                    console.error('error uploading data, please refresh')
                                    return reject(f.name);
                                } else {
                                    // set up obj for dynamo
                                    const sharedProjectId = folderObjList.filter(obj => obj.name === selectedFolder)[0].sharedProjectId;
                                    dynamoArr.push({
                                        ...data,
                                        uploadDate: new Date().getTime(),
                                        name: f.name,
                                        lastModified: f.lastModified,
                                        lastModifiedDate: f.lastModifiedDate,
                                        size: f.size,
                                        type: f.type,
                                        selectedFolder,
                                        project_id: sharedProjectId ? sharedProjectId : project_id, //key
                                        reqId: f.name,
                                        fileCategory: selectedFolder,
                                        tags: 'empty',
                                        ...(auth.policy.filterUser) ? { filterUser: auth.user } : {},
                                    })
                                    return resolve();
                                }
                            })
                    })
                )

                if (currentSize >= 30000000 || ((id + 1) % 100 === 0 || id === assets.length - 1)) {
                    // carico ogni 100 documenti o file singoli se > 30MB
                    const results = await Promise.allSettled(promises);
                    results.filter(r => r.status === 'rejected').forEach(r => failedFiles.push(r.reason));
                    promises.length = 0
                    currentSize = 0;

                    // upload in dynamo
                    let dynamoArrRequest = [];
                    for (let i = 0; i < dynamoArr.length; i++) {
                        dynamoArrRequest.push(dynamoArr[i]);

                        if ((i + 1) % 100 === 0 || i === dynamoArr.length - 1) {
                            const putReq = await axios({
                                method: "post",
                                url: `${process.env.REACT_APP_API_BASE_URL}/assets`,
                                headers: {
                                    'user_id': REACT_APP_USER_ID || auth.ssmParams.USER_ID,
                                    "content-type": "application/json",
                                    "Authorization": await getSessionIdToken(),
                                    "action": 'new-item-dynamo-batch',
                                },
                                data: JSON.stringify(dynamoArrRequest)
                            })

                            dynamoArrRequest = [];
                        }
                    }
                    dynamoArr = [];
                }
            }

            if (failedFiles.length > 0) {
                const fileList = failedFiles.length <= 5
                    ? failedFiles.join(', ')
                    : failedFiles.slice(0, 5).join(', ') + ` and ${failedFiles.length - 5} more`;
                setOpenAsset({ open: true, message: `Upload failed for ${failedFiles.length} file(s): ${fileList}`, duration: null })
            } else {
                setOpenAsset({ open: true, message: 'Upload completed', duration: 6000 })
            }
            await refresh();
            handleClearAssetsAll(folderName);
        } catch (err) {
            console.error('Error during upload process');
            setOpenAsset({ open: true, message: 'Upload process failed unexpectedly', duration: null })
        } finally {
            updateObjState(isLoadingAsset, setIsLoadingAsset, false, folderName);
        }
    }

    const handleButtonClick = (e) => {
        // Trigger a click on the hidden file input
        fileInputRef.current.click();
    };

    return (
        <Box id='pino'>
            {folderObjList && folderObjList.filter(f => f.name === selectedFolder).map(f => {
                const folder = f.name, folderPath = f.s3, displayNameKey = displayName ? displayName : f.name;
                return (
                    <Stack direction={direction}
                        justifyContent="flex-start"
                        alignItems={direction === 'row' ? 'center' : 'flex-start'}
                        spacing={2}
                        key={displayNameKey}
                    >
                        {inLaunch === false && (
                            <Stack direction='column' spacing={1.5} sx={{ width: '100%' }}>
                                <Box
                                    onDragOver={(e) => { e.preventDefault(); setIsDragOver(true); }}
                                    onDragLeave={() => setIsDragOver(false)}
                                    onDrop={async (e) => {
                                        e.preventDefault();
                                        setIsDragOver(false);
                                        const droppedFiles = await getFilesFromDataTransfer(e.dataTransfer);
                                        if (droppedFiles.length > 0) {
                                            setSelectedAssets(prev => {
                                                const existing = prev[folder] ? [...prev[folder]] : [];
                                                const existingNames = new Set(existing.map(f => f.name));
                                                return { ...prev, [folder]: [...existing, ...droppedFiles.filter(f => !existingNames.has(f.name))] };
                                            });
                                        }
                                    }}
                                    sx={{
                                        width: '100%',
                                        border: isDragOver ? '2px dashed' : '2px dashed #ccc',
                                        borderColor: isDragOver ? 'primary.main' : '#ccc',
                                        borderRadius: 2,
                                        px: 3,
                                        py: 4,
                                        textAlign: 'center',
                                        backgroundColor: isDragOver ? 'rgba(66,135,245,0.06)' : 'transparent',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s',
                                        '&:hover': { borderColor: 'primary.main', backgroundColor: 'rgba(66,135,245,0.03)' },
                                    }}
                                    onClick={() => {
                                        const input = document.createElement('input');
                                        input.type = 'file';
                                        input.multiple = true;
                                        input.accept = f.ext || '';
                                        input.onchange = (event) => handleAssetsInput(event, folder);
                                        input.click();
                                    }}
                                >
                                    <Stack direction='column' spacing={0.5} justifyContent='center' alignItems='center'>
                                        <SvgIcon component={UploadImagesLogo} viewBox="0 0 24.01 24.01" color={isDragOver ? 'primary' : 'disabled'} sx={{ fontSize: 40 }} />
                                        <Typography variant="body2" color={isDragOver ? 'primary' : 'text.secondary'}>
                                            {isDragOver ? 'Drop files here' : 'Click here to select files or drag & drop'}
                                        </Typography>
                                    </Stack>
                                </Box>
                                {selectedAssets[folder] && selectedAssets[folder].length > 0 && (
                                    <Box sx={{
                                        maxHeight: 160,
                                        overflowY: 'auto',
                                        border: '1px solid #eee',
                                        borderRadius: 1,
                                        px: 1.5,
                                        py: 0.5,
                                    }}>
                                        {Array.from(selectedAssets[folder]).map((file, idx) => {
                                            const result = validationResults[folder]?.[idx];
                                            return (
                                                <Stack key={idx} direction='row' alignItems='center'
                                                    sx={{ py: 0.3, borderBottom: idx < selectedAssets[folder].length - 1 ? '1px solid #f0f0f0' : 'none' }}
                                                >
                                                    {result?.status === 'blocked' && (
                                                        <Tooltip title={result.errors.join(', ')}>
                                                            <ErrorIcon sx={{ color: 'error.main', fontSize: 18, mr: 0.5, flexShrink: 0 }} />
                                                        </Tooltip>
                                                    )}
                                                    {result?.status === 'warning' && (
                                                        <Tooltip title={result.warnings.join(', ')}>
                                                            <WarningIcon sx={{ color: 'warning.main', fontSize: 18, mr: 0.5, flexShrink: 0 }} />
                                                        </Tooltip>
                                                    )}
                                                    <Typography variant="body2" noWrap sx={{ flex: 1, minWidth: 0 }}>{file.name}</Typography>
                                                    <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0, mx: 1 }}>{formatFileSize(file.size)}</Typography>
                                                    <IconButton size="small" onClick={() => handleRemoveFile(folder, idx)} sx={{ flexShrink: 0 }}>
                                                        <CloseIcon fontSize="small" />
                                                    </IconButton>
                                                </Stack>
                                            );
                                        })}
                                    </Box>
                                )}
                                <Stack direction='row' spacing={2} alignItems='center' justifyContent='center'>
                                    {(() => {
                                        const folderValidation = validationResults[folder] || [];
                                        const hasBlocked = folderValidation.some(r => r.status === 'blocked');
                                        const hasWarnings = folderValidation.some(r => r.status === 'warning');
                                        return (
                                            <>
                                                <Button
                                                    variant="contained"
                                                    color='secondary'
                                                    size='small'
                                                    loading={isLoadingAsset[folder]}
                                                    loadingIndicator={
                                                        <Stack direction='row' alignItems='center'>
                                                            <CircularProgress color="inherit" size={16} variant='determinate' value={assetProgress} />
                                                            <Typography variant='body2' ml='0.5em'>{assetProgress.toFixed(0)}%</Typography>
                                                        </Stack>
                                                    }
                                                    disabled={!selectedAssets[folder]?.length || hasBlocked}
                                                    onClick={() => {
                                                        if (hasWarnings) {
                                                            setPendingUpload({ assets: selectedAssets[folder], folderName: folder, folderPath });
                                                            setWarningDialogOpen(true);
                                                        } else {
                                                            handleUploadAsset(selectedAssets[folder], folder, folderPath);
                                                        }
                                                    }}
                                                >
                                                    UPLOAD
                                                </Button>
                                                {hasBlocked && (
                                                    <Button size="small" color="error" variant="text" onClick={() => setErrorDialogOpen(true)}>
                                                        See errors
                                                    </Button>
                                                )}
                                            </>
                                        );
                                    })()}
                                    {selectedAssets[folder] && selectedAssets[folder].length > 0 && (
                                        <Chip label={`${selectedAssets[folder].length} files selected`} variant="outlined" onDelete={() => handleClearAssetsAll(folder)} sx={{ borderRadius: 1 }} />
                                    )}
                                </Stack>
                            </Stack>
                        )}
                        {inLaunch && (
                            <Stack direction='row' spacing={2} alignItems='center' >
                                <input
                                    type="file"
                                    // multiple
                                    hidden
                                    accept={f.ext}
                                    ref={fileInputRef}
                                    onChange={(event) => handleAssetsInput(event, folder, folderPath, inLaunch)}
                                    onClick={(event) => {
                                        event.target.value = null //per poter selezionare lo stesso file di seguito
                                    }}

                                />
                                <Button
                                    variant="outlined"
                                    component="label"
                                    color='primary'
                                    size='small'
                                    fullWidth
                                    sx={{ height: '3.05em' }}
                                    onMouseDown={(event) => handleButtonClick(event)}
                                >
                                    Upload New File
                                    <FileUploadIcon color='primary' />
                                </Button>
                            </Stack>
                        )}

                    </Stack>
                )

            })
            }



            {/* Error dialog - blocking validation */}
            <Dialog open={errorDialogOpen} onClose={() => setErrorDialogOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ color: 'error.main' }}>
                    Upload blocked — invalid filenames
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        The following files cannot be uploaded because their names violate naming rules.
                        Please rename them and try again.
                    </DialogContentText>

                    <Box sx={{ mt: 2, mb: 2, p: 1.5, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
                        <Typography variant="subtitle2" gutterBottom>Naming rules:</Typography>
                        <Typography variant="body2" component="ul" sx={{ pl: 2, m: 0 }}>
                            {VALIDATION_RULES.blocking.map((rule, i) => (
                                <li key={i}>{rule}</li>
                            ))}
                        </Typography>
                    </Box>

                    <Box sx={{ maxHeight: 200, overflowY: 'auto' }}>
                        {Object.entries(validationResults).flatMap(([folder, results]) =>
                            results.filter(r => r.status === 'blocked').map((r, i) => (
                                <Stack key={`${folder}-${i}`} direction="row" spacing={1} alignItems="flex-start" sx={{ mb: 0.5 }}>
                                    <ErrorIcon sx={{ color: 'error.main', fontSize: 16, mt: 0.3 }} />
                                    <Box>
                                        <Typography variant="body2" fontWeight="bold">{r.file.name}</Typography>
                                        {r.errors.map((err, j) => (
                                            <Typography key={j} variant="caption" display="block" color="error.main">
                                                — {err}
                                            </Typography>
                                        ))}
                                    </Box>
                                </Stack>
                            ))
                        )}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setErrorDialogOpen(false)}>Close</Button>
                </DialogActions>
            </Dialog>

            {/* Warning dialog - confirmation before upload */}
            <Dialog open={warningDialogOpen} onClose={() => setWarningDialogOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ color: 'warning.main' }}>
                    Some filenames may cause issues
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        The following files have names that could cause problems during pagination.
                        Do you want to proceed with the upload anyway?
                    </DialogContentText>

                    <Box sx={{ mt: 2, mb: 2, p: 1.5, backgroundColor: '#fff8e1', borderRadius: 1 }}>
                        <Typography variant="subtitle2" gutterBottom>Recommended naming practices:</Typography>
                        <Typography variant="body2" component="ul" sx={{ pl: 2, m: 0 }}>
                            {VALIDATION_RULES.warning.map((rule, i) => (
                                <li key={i}>{rule}</li>
                            ))}
                        </Typography>
                    </Box>

                    <Box sx={{ maxHeight: 200, overflowY: 'auto' }}>
                        {pendingUpload && (validationResults[pendingUpload.folderName] || [])
                            .filter(r => r.status === 'warning')
                            .map((r, i) => (
                                <Stack key={i} direction="row" spacing={1} alignItems="flex-start" sx={{ mb: 0.5 }}>
                                    <WarningIcon sx={{ color: 'warning.main', fontSize: 16, mt: 0.3 }} />
                                    <Box>
                                        <Typography variant="body2" fontWeight="bold">{r.file.name}</Typography>
                                        {r.warnings.map((w, j) => (
                                            <Typography key={j} variant="caption" display="block" color="warning.dark">
                                                — {w}
                                            </Typography>
                                        ))}
                                    </Box>
                                </Stack>
                            ))
                        }
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setWarningDialogOpen(false)}>Cancel</Button>
                    <Button onClick={() => {
                        setWarningDialogOpen(false);
                        handleUploadAsset(pendingUpload.assets, pendingUpload.folderName, pendingUpload.folderPath);
                    }} color="warning" variant="contained">
                        Upload anyway
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={openAsset.open}
                autoHideDuration={openAsset.duration}
                onClose={handleCloseAsset}
                message={openAsset.message}
                action={
                    <React.Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseAsset}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                }
            />

            <Typography sx={{ marginBottom: '1em' }}
                variant="body2"
                color={Primarytheme.palette.neutral.dark}> </Typography>
        </Box >

    )
}